import CardRawatibPrayer from './CardPrayerRawatib';

export default CardRawatibPrayer;
